var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-span-2"},[_c('ul',{staticClass:"text-center font-light",class:_vm.isDark? 'text-orange-600':'text-white'},_vm._l((_vm.errors),function(error,i){return _c('li',{key:i},[_vm._v(_vm._s(error))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }